import React from 'react';
import { useTranslation } from 'react-i18next';

function TitleItem({ title, value }) {
    const { t } = useTranslation();
    return (
        <span>
            {t(`${title}`)} {value}
        </span>
    );
}

export default TitleItem;
